var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcessSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "1.42108547e-12%",
    x2: "0%",
    y2: "100%",
    id: "linearGradient-spinner"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B8DB3",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B8DB3",
    stopOpacity: 0.4,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDFA8-M019-PK-Mutations-List",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "M019/PK-Mutations-List/Desktop",
    transform: "translate(-637.000000, -147.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(637.000000, 147.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,2 C6.4771525,2 2,6.4771525 2,12",
    id: "Oval",
    stroke: "url(#linearGradient-spinner)",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,12 C16.4771525,12 12,16.4771525 12,22",
    id: "Oval",
    stroke: "url(#linearGradient-spinner)",
    strokeWidth: 3,
    strokeLinecap: "round",
    transform: "translate(17.000000, 17.000000) rotate(-180.000000) translate(-17.000000, -17.000000) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessSpinner);
export default __webpack_public_path__ + "static/media/process-spinner.ae27337ef71d52f81aaa653345c17d9a.svg";
export { ForwardRef as ReactComponent };